import { z } from "zod";
import { track } from "@/lib/analytics";

export const ContactSchema = z.object({
  name: z.string().min(2).max(80),
  email: z.email(),
  brief: z.string().min(10).max(2000),
});

export type ContactPayload = z.infer<typeof ContactSchema>;

const ENDPOINT = import.meta.env.VITE_FORMSPREE_ENDPOINT as string | undefined;

export const submitContact = async (payload: ContactPayload): Promise<void> => {
  if (!ENDPOINT) throw new Error("contact endpoint not configured");
  const res = await fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`submit failed: ${res.status}`);
  track("contact_submit");
};
